<template>
  <div>
    <label
      for="upload-file"
      class="button-gemnote button-gemnote--small"
      :class="{
        'whitebutton-gemnote whitebutton-gemnote--small text-sm text-normal': isWhiteVariant,
        disabled: isDisabled
      }"
      :style="customStyles"
    >
      <input
        type="file"
        id="upload-file"
        hidden
        :disabled="isDisabled"
        @change="handleFile"
        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
      />
      <span>{{ text }} </span>
    </label>
  </div>
</template>

<script>
import i18n from '../../internatinalization/i18n'

export default {
  props: {
    text: {
      type: String,
      default: 'Upload CSV file'
    },
    isDisabled: {
      type: Boolean,
      default: false
    },

    isWhiteVariant: {
      type: Boolean,
      default: true
    },

    customStyles: {
      type: String,
      default: ''
    }
  },

  data: () => ({
    accepted: [
      'text/csv',
      'text/plain',
      'application/csv',
      'text/comma-separated-values',
      'application/excel',
      'application/vnd.ms-excel',
      'application/vnd.msexcel',
      'text/anytext',
      'application/octet-stream',
      'application/txt'
    ]
  }),

  methods: {
    handleFile(e) {
      const file = e.target.files[0]
      const accepted = this.accepted.includes(file.type)

      // Check if file is Valid with accepted file types
      if (!accepted) {
        return this.$store.dispatch('notification/pushNotification', {
          type: 'error',
          messages: [i18n.t('recipients.action.upload-validation-error')]
        })
      }
      this.$emit('import', e, file)
    }
  }
}
</script>

<style lang="scss" scoped>
label {
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  padding: 0 1.5rem;
  height: 3.25rem !important;
  color: #232220;
  font-weight: 500;

  &.disabled {
    cursor: not-allowed;
    border: 1px solid #a09c95 !important;
    color: #a09c95;
  }

  &.text-sm {
    font-size: 0.875rem;
  }

  &.text-bold {
    font-weight: bold;
  }
  &.text-normal {
    // font-weight: normal;
  }

  &.whitebutton-gemnote--small {
    height: 2.5rem;
    // border: 1px solid #9b9b9b;
    border: 1px solid #232220;
    padding: 0 2rem;
  }

  &.button-gemnote--small {
    height: 2.5rem;
    display: flex !important;
    align-items: center !important;
  }
}
</style>
